export default __webpack_public_path__ + "static/media/gr_flag.797d118b.svg";